import { Link } from 'react-router-dom';
import './Footer.css';

/**
 * Footer Component
 * Displays legal links and copyright information required for French websites
 */
export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__content">
          <div className="footer__links">
            <Link to="/mentions-legales" className="footer__link">
              Mentions Légales
            </Link>
            <Link to="/politique-confidentialite" className="footer__link">
              Politique de Confidentialité
            </Link>
            <Link to="/cgu" className="footer__link">
              CGU
            </Link>
            <Link to="/cookies" className="footer__link">
              Cookies
            </Link>
          </div>
          
          <div className="footer__copyright">
            © {currentYear} Bookiner. Tous droits réservés.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
